module.exports = __webpack_public_path__ + "static/media/seed4.5d3e9e52.svg";